var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDetailIntro = function SvgDetailIntro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#333",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8 L0,0 C5.60672261,0 5.01413002,0 8,0",
    transform: "translate(5 5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,18 L10,10 C15.6067226,10 15.01413,10 18,10",
    transform: "rotate(-180 16.5 16.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1L0 7 6 7",
    transform: "rotate(180 11.5 6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.62713467,6 L6,0.533918334",
    transform: "rotate(-174 11.643 5.597)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    transform: "translate(5 17)",
    d: "M0 1.50546242e-13L0 6 6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.627134667,6 L5,0.533918334",
    transform: "rotate(-174 5.931 11.36)"
  })))));
};
export default SvgDetailIntro;